import { render, staticRenderFns } from "./AutomateLinks.vue?vue&type=template&id=2fb3ddac&scoped=true&"
import script from "./AutomateLinks.vue?vue&type=script&lang=ts&"
export * from "./AutomateLinks.vue?vue&type=script&lang=ts&"
import style0 from "./AutomateLinks.vue?vue&type=style&index=0&id=2fb3ddac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb3ddac",
  null
  
)

export default component.exports